import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, Heading1 } from '@blueprint/ui';

export const PromptContent = styled('div')(css`
    display: flex;
    flex-direction: column;
    align-items: center;
`);

export const SignInButton = styled(Button)(css`
    min-width: 250px;
`);

export const RegisterButton = styled(Button)(
    ({ theme: { spacing } }) => css`
        margin: ${spacing['spacing-2']} 0;
    `
);

export const PromptHeading = styled(Heading1)<{ hasSubtitle?: boolean }>(
    ({ theme: { spacing }, hasSubtitle }) => css`
        text-align: center;
        margin: ${spacing['spacing-1']} ${spacing['spacing-2']}
            ${hasSubtitle ? spacing['spacing-1'] : spacing['spacing-4']};
    `
);

export const PromptSubtitle = styled('p')(
    ({ theme: { spacing } }) => css`
        margin-top: 0;
        margin-bottom: ${spacing['spacing-3']};
        text-align: center;
        line-height: ${spacing['spacing-3']};
    `
);
